import { createApi } from '@reduxjs/toolkit/query/react';
import auth0APIQuery from './base';

const auth0Api = createApi({
  reducerPath : 'auth0Api',
  baseQuery   : auth0APIQuery(),
  endpoints   : () => ({}),
});

export default auth0Api;
